import { render, staticRenderFns } from "./my-orders.vue?vue&type=template&id=647155fa&scoped=true&"
import script from "./js/my-orders.js?vue&type=script&lang=js&"
export * from "./js/my-orders.js?vue&type=script&lang=js&"
import style0 from "./my-orders.vue?vue&type=style&index=0&id=647155fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647155fa",
  null
  
)

export default component.exports